
<iframe [style.height]="innerHeight" id="ActiveInvoicingframe" style="width: 100%;" [src]="certurl | safe" title="Active Invoicing"></iframe>
